export const FAVORITES_LOCAL_STORAGE_KEY = '1';
export const FAVORITES_EVENT = 'favorites-updated';

export type UserFavorite = {
  action: string;
  endpoint: string;
  payload: { listing: number[] };
  data: { [key: string]: string };
};

export const buildUserFavorite = (ids: number[]): UserFavorite => ({
  action: 'POST',
  endpoint: '/api/favourite',
  payload: { listing: ids },
  data: {},
});

export const readUserFavorite = (): UserFavorite | null => {
  if (typeof window === 'undefined') return null;
  const raw = localStorage.getItem(FAVORITES_LOCAL_STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as UserFavorite;
  } catch (error) {
    console.error('Failed to parse favorites from localStorage:', error);
    return null;
  }
};

export const writeUserFavorite = (favorite: UserFavorite) => {
  if (typeof window === 'undefined') return;
  localStorage.setItem(FAVORITES_LOCAL_STORAGE_KEY, JSON.stringify(favorite));
  window.dispatchEvent(new Event(FAVORITES_EVENT));
};

export const setUserFavoriteIds = (ids: number[]) => {
  writeUserFavorite(buildUserFavorite(ids));
};

export const removeUserFavoriteId = (id: number) => {
  const favorite = readUserFavorite();
  if (!favorite) return;
  const nextIds = favorite.payload.listing.filter(
    (existingId) => existingId !== id,
  );
  setUserFavoriteIds(nextIds);
};

export const clearUserFavorites = () => {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(FAVORITES_LOCAL_STORAGE_KEY);
  window.dispatchEvent(new Event(FAVORITES_EVENT));
};
